<template>
  <kst-print-table input-mode :data="items">
    <b-table-column
      v-slot="{ column, row }"
      field="DispatchID"
      :label="PurItemCatalog.DispatchID.PrintLabel"
    >
      <kst-value :field="column.field" :data="row" :catalog="PurItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-sku-large"
      field="SKU"
      :label="PurItemCatalog.SKU.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="PurItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-qty-print"
      field="Quantity"
      :label="PurItemCatalog.Quantity.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="PurItemCatalog">
        <kst-value field="Packaging" :data="row" :catalog="PurItemCatalog"/>
      </kst-value>
    </b-table-column>

    <template v-if="access.Fld_Amount">
      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-price"
        field="BuyPrice"
        :label="PurItemCatalog.BuyPrice.Label"
      >
        <kst-value :field="column.field" :data="row" :catalog="PurItemCatalog"/>
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-subtotal"
        field="ExpenseAmount"
        :label="PurItemCatalog.ExpenseAmount.Label"
      >
        <kst-value :field="column.field" :data="row" :catalog="PurItemCatalog"/>
      </b-table-column>
    </template>
  </kst-print-table>
</template>

<script>
import PurItemCatalog from "../PurItemCatalog.js";

export default {
  props: {
    access: Object,
    items: Array
  },
  data: () => ({
    PurItemCatalog: PurItemCatalog
  })
}
</script>